import * as React from 'react'

import { BaseEventModel } from 'app/models/baseEventModel'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

const color = '#707070'

type ChangeAreaBlockProps = {
  changeArea: BaseEventModel
  index: number
}

const prepareTooltipInfo = (changeArea: BaseEventModel): BaseEventModel => {
  const info: BaseEventModel = {
    startTime: changeArea.startTime,
    endTime: changeArea.endTime,
    typeName: 'eventName.changeArea',
    color,
  }
  return info
}

export const ChangeAreaBlock: React.FC<ChangeAreaBlockProps> = React.memo(
  (props: ChangeAreaBlockProps) => {
    const scene = useScene()

    const HEIGHT = scene.height - 28
    const changeArea = props.changeArea

    const width = scene.widthOf(changeArea.startTime, changeArea.endTime)
    const left = scene.timeToX(changeArea.startTime)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          position: 'absolute',
          top: 0,
          bottom: 0,
             paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          data-tip={JSON.stringify(prepareTooltipInfo(changeArea))}
          data-for="eventTooltip"
          style={{
            background: color,
            height: HEIGHT,
            width: width,
            opacity: 0.5,
            pointerEvents: 'auto',
          }}
        />
      </div>
    )
  },
)

ChangeAreaBlock.displayName = 'ChangeAreaBlock'
